import { getStaffScopedApiPrefixOrCareAdvisor } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { ObjectType, OralHealthCoachingReport } from './types/types';

export const deleteOralHealthCoachingReportObject = async (
  oral_health_coaching_report_id: string,
  object_id: string,
  object_type: ObjectType,
  userRole?: string,
): Promise<OralHealthCoachingReport> => {
  const prefix = getStaffScopedApiPrefixOrCareAdvisor(userRole);
  const { data } = await client.delete<OralHealthCoachingReport>(
    `${prefix}/oral_health_coaching_reports/${oral_health_coaching_report_id}/${object_type}/${object_id}`,
  );

  return data;
};
